<template>
    <div class="collection-c" @click="clickCollection">
        <div class="icon">
            <div :class="[isCollection?'collection-icon':'no-collection-icon']"/>
        </div>
        <div class="count">{{ setCount(collectionCount) }}</div>
    </div>
</template>
<script>
import { sendCollection } from '@/request/request'
import { importLogin } from '@/utils/login'
import { getUserInfo,getInteracitonCountApi } from '@/request/request'
import { env } from "@/env"

export default {
    props: ['collectionData'],
    data() {
        return {
            collectionCount: 0, // 收藏数量
            isCollection: false, // 收藏状态
            isSendCollection: false,
            isLogin: false
        }
    },
    mounted() {
        window.EVENT_BUS.$on('loginSuccess',this.handleLoginSuccess)
    },
    watch: {
        collectionData: {
            handler: function (newValue, oldValue) {
               this.isCollection = newValue?.isCollection || false
               this.collectionCount = newValue?.collectionCount || 0
            },
            deep: true
        }
    },
    methods: {
        async handleLoginSuccess() {
            try {
                await this.getCollectionCount()
                // 缓存收藏处理
                const collectionArticle = localStorage.getItem('collectionArticle');
                if(collectionArticle && !this.isCollection)this.hanldeSendCollection()
                localStorage.removeItem('collectionArticle');
            } catch (error) {}
        },
        // 获取收藏数量+状态
        async getCollectionCount() {
            let res = await getInteracitonCountApi()
            if(res.code == 1 && res.data) {
                let countObj = res?.data?.[`mp_${window.pcArticleInfo?.news_id}`]
                // 收藏
                this.isCollection = countObj?.[11]?.optionInfos?.[0]?.operated,
                this.collectionCount = countObj?.[11]?.optionInfos?.[0]?.count
            }
        },
        setCount(count) {
            if( count == 0) return '收藏'
            let num = "";
            if (999 > count > 0) {
                num = count;
            } else if (count > 999) {
                num = `999+`;
            }
            return num;
        },
        // 收藏
        clickCollection() {
            if(this.isSendCollection) return
			// 初始化登录态-尝试同步游客点赞
            getUserInfo().then((res) => {
                if (res?.code == 1 && res?.data) {
                    this.hanldeSendCollection()
                }else {
                    if(!this.isCollection)localStorage.setItem('collectionArticle', true);
                    importLogin().then((res)=>{
                        const loginIndex = res.loginIndex
                        loginIndex.login()
                    })
                    return
                }
            })
            .catch((error) => {
                console.log('获取用户信息失败', error)
            })

        },

        async hanldeSendCollection() {
             try {
                this.isSendCollection = true
                const res = await sendCollection(!this.isCollection)
                if(res?.code == 400001) {
                    this.isCollection = !this.isCollection
                    this.collectionCount = this.isCollection ? this.collectionCount + 1 : this.collectionCount - 1
                    if(this.isCollection) {
                        window?.sohuSpm?.sendAction({ acode: 10920 });
                        const jumpHref = {
                            test: '//test-www.sohu.com/ucenter/collection',
                            pre:'//pre-www.sohu.com/ucenter/collection',
                            prod: '//www.sohu.com/ucenter/collection'
                        }[env || 'prod']

                        this.$toast('收藏成功，',3000,`<a href=${jumpHref} target="_blank" style="color:#FFD100;text-decoration:underline">去我的收藏</a>`,true)
                    }else {
                        window?.sohuSpm?.sendAction({ acode: 10921 });
                        // 取消收藏提示
                        this.$toast('已取消收藏',2000)
                    }
                }
                this.isSendCollection = false
            } catch (error) {
                this.isSendCollection = false
            }
        }
    }

}
</script>
<style lang="less" scoped>
.collection-c {
    &:hover {
        cursor: pointer;
    }
    .icon {
        width: 48px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .collection-icon {
            width: 22px;
            height: 22px;
            background: url('../../images/wap-yellow-collection.png');
            background-size: 100% 100%;

        }
        .no-collection-icon {
            width: 22px;
            height: 22px;
            background: url('../../images/wap-black-collection.png');
            background-size: 100% 100%;
        }
    }
    .icon:hover {
        background: #f2f2f2;
    }
    .count {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #111111;
        line-height: 17px;
        height: 17px;
        text-align: left;
        font-style: normal;
        margin-top: 4px;
        margin-bottom: 24px;
        text-align: center;
    }
  }
</style>